export type GameCommandKind =
  | 'return'
  | 'menu'
  | 'restart'
  | 'help'
  | 'coach'
  | 'board'
  | 'commands'
  | 'next'
  | 'chat'
export default function GameCommandIcon({
  kind,
  className,
}: {
  kind: GameCommandKind
  className?: string
}) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {kind === 'return' && <path d="m10 5-7 7 7 7M3 12h18" />}
      {kind === 'menu' && <path d="M4 5h16M4 12h16M4 19h16" />}
      {kind === 'restart' && <path d="M20 5v6h-6M20 11a8 8 0 1 0-1 7" />}
      {kind === 'help' && <path d="M8 16c0-3-3-3-3-7a7 7 0 0 1 14 0c0 4-3 4-3 7zM8 19h8M10 22h4" />}
      {kind === 'coach' && (
        <path d="m10 2 2.5 6.5L19 11l-6.5 2.5L10 20l-2.5-6.5L1 11l6.5-2.5zM20 2v5M17.5 4.5h5M20 17v5M17.5 19.5h5" />
      )}
      {kind === 'board' && (
        <>
          <rect x="3" y="3" width="18" height="18" rx="1" />
          <path d="M9 3v18M15 3v18M3 9h18M3 15h18" />
        </>
      )}
      {kind === 'commands' && (
        <>
          <path d="M4 6h16M4 12h16M4 18h16" />
          <circle cx="9" cy="6" r="2" fill="currentColor" />
          <circle cx="16" cy="12" r="2" fill="currentColor" />
          <circle cx="8" cy="18" r="2" fill="currentColor" />
        </>
      )}
      {kind === 'next' && <path d="m14 5 7 7-7 7M21 12H3" />}
      {kind === 'chat' && <path d="M3 3h18v14H9l-6 4zM7 7h10M7 12h7" />}
    </svg>
  )
}
